
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_14cnr_x4qz0_3",
  "trigger": "awsui_trigger_14cnr_x4qz0_15",
  "dropdown": "awsui_dropdown_14cnr_x4qz0_18",
  "nowrap": "awsui_nowrap_14cnr_x4qz0_29",
  "open": "awsui_open_14cnr_x4qz0_32"
};
  